import type { JobStatus } from '@/lib/api/types';

export const EVENT_TYPES = ['run.progress', 'run.zones', 'run.log', 'run.finished'] as const;
export type EventType = (typeof EVENT_TYPES)[number];

export interface RunEvent {
  type: EventType;
  id: string;
  name: string;
  status: JobStatus;
  tasks_total: number;
  tasks_done: number;
  tasks_failed: number;
  places_found: number;
  places_new: number;
  api_calls_used: number;
  error_message: string | null;
}

export function parseEvent(raw: string): RunEvent | null {
  try {
    const obj = JSON.parse(raw) as { type?: unknown };
    if (typeof obj.type !== 'string') return null;
    if (!(EVENT_TYPES as readonly string[]).includes(obj.type)) return null;
    return obj as RunEvent;
  } catch {
    // Un chunk SSE tronqué ne doit jamais faire tomber le flux : on jette
    // l'événement et on attend le suivant.
    return null;
  }
}
